import React from 'react'
import ReactDOM from 'react-dom'
import { Provider } from 'react-redux'
import { Router } from 'react-router'
import { ToastContainer } from 'react-toastify'
import Cookies from 'universal-cookie'
import numeral from 'numeral'
import 'numeral/locales/es'

import routes from './routes'
import reducers from './reducers'
import { INICIAR_SESION, CERRAR_SESION, ASIGNAR_USUARIO_SESION } from './actions/types'
import { getUserFromToken } from './actions/auth'

import history from './utils/history'
import store from './utils/store'
import './utils/polyfills.js'

import './css/bootstrap.css'
import './css/fonts.css'
import './css/font-awesome.min.css'
import './css/animate.css'
import './css/layout.css'
//import 'react-toastify/dist/ReactToastify.min.css'
import './css/custom-toastify.css'

numeral.locale('es')

const cookies = new Cookies()
const token = cookies.get('token')

if (token) {
    const d = store.dispatch
    d({ type: INICIAR_SESION })
    getUserFromToken().then(data => {
        d({ type: ASIGNAR_USUARIO_SESION, payload: data })
    }).catch(err => {
        console.log(err)
        store.dispatch({ type: CERRAR_SESION })
        history.push(window.FOLDER + '/signin')
    })
}

window.root = window.document.getElementById('root')

ReactDOM.render(
    <Provider store={store}>
        <div>
            <Router history={ history }>
                { routes }
            </Router>
            {/* <ToastContainer toastClassName="toastify" autoClose={60000*3} /> */}
            <ToastContainer toastClassName="toastify" />
        </div>
    </Provider>,
    window.root
)



// WEBPACK FOOTER //
// ./src/index.js